import React, { lazy } from 'react';
import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import profileRouterRoutes from './subrouters/Profile/routes';
import portfolioRouterRoutes from './subrouters/Portfolio/routes';
import { messagingRoutes } from './subrouters/Messaging';
import Notifications from './pages/Notifications';
import { Navigate } from 'react-router-dom';
import adminDashboardRoutes from './subrouters/AdminDashboard/routes';
import InvestorVerificationPreview from './pages/InvestorVerificationPreview';
import { ContactRouter, contactsRoutes } from './subrouters/Contacts';
import { enterpriseRouterRoutes } from './subrouters/Enterprise';

const ProfileRouter = lazy(() => import('./subrouters/Profile'));
const PortfolioRouter = lazy(() => import('./subrouters/Portfolio'));
const AdminDashboard = lazy(() => import('./subrouters/AdminDashboard'));
const MessagingRouter = lazy(() => import('./subrouters/Messaging'));
const EnterpriseRouter = lazy(() => import('./subrouters/Enterprise'));

export default [
  {
    path: 'admin-dashboard',
    routes: adminDashboardRoutes,
    element: <AdminDashboard />,
  },
  {
    path: 'profile/edit',
    routes: profileRouterRoutes,
    element: <ProfileRouter />,
  },
  { path: 'profile', element: <Navigate to="edit" replace /> },
  {
    path: 'notifications',
    element: Notifications,
  },
  {
    path: 'messaging',
    routes: messagingRoutes,
    element: <MessagingRouter />,
  },
  {
    path: 'investor-verification-preview',
    element: InvestorVerificationPreview,
  },
  {
    path: 'portfolio',
    routes: portfolioRouterRoutes,
    element: <PortfolioRouter />,
  },
  {
    path: 'contacts',
    routes: contactsRoutes,
    element: ContactRouter,
  },
  {
    path: 'enterprise/:id',
    routes: enterpriseRouterRoutes,
    element: <EnterpriseRouter />,
  },
  { index: true, element: <Navigate to="portfolio" replace /> },
] as Array<EnhancedRouteProps>;
